// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting24Filled: FC<Vetting24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M9.68 2.56a2.912 2.912 0 0 1 4.64 0 2.911 2.911 0 0 0 2.715 1.125 2.91 2.91 0 0 1 3.28 3.28 2.911 2.911 0 0 0 1.126 2.716 2.91 2.91 0 0 1 0 4.639 2.912 2.912 0 0 0-1.125 2.716 2.911 2.911 0 0 1-3.28 3.28 2.91 2.91 0 0 0-2.716 1.126 2.912 2.912 0 0 1-4.64 0 2.91 2.91 0 0 0-2.716-1.125 2.911 2.911 0 0 1-3.28-3.28 2.912 2.912 0 0 0-1.125-2.717 2.91 2.91 0 0 1 0-4.639 2.911 2.911 0 0 0 1.125-2.716 2.911 2.911 0 0 1 3.28-3.28A2.911 2.911 0 0 0 9.68 2.56Zm1.27 10.14L8.8 10.6 7.4 12l3.55 3.55L16.6 9.9l-1.4-1.45-4.25 4.25Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting24Filled;
